import React from 'react';
import { Button } from 'react-bootstrap';
import './DynamicCloseButton.css';

const DynamicCloseButton = ({ onClick, children = 'Close', variant = 'secondary', size, className = '' }) => {
    return (
        <Button
            variant={variant}
            size={size}
            onClick={onClick}
            className={`dynamic-close-btn ${className}`}
        >
            {children}
        </Button>
    );
};

export default DynamicCloseButton;
